module.exports = __webpack_public_path__ + "img/applicationEpaylater.6a2fdb8d.svg";